import React, { useEffect, useState } from 'react';
import axios from 'axios';

function Exchanges() {
  const [exchanges, setExchanges] = useState([]);

  useEffect(() => {
    axios.get('/api/getExchanges.php')
      .then(response => setExchanges(response.data))
      .catch(error => console.error(error));
  }, []);

  return (
    <div>
      <h2>Intercambios</h2>
      <table className="table table-bordered table-hover">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Volumen 24h</th>
            <th>Mercados</th>
            <th>URL</th>
          </tr>
        </thead>
        <tbody>
          {exchanges.map(exchange => (
            <tr key={exchange.id}>
              <td>{exchange.name}</td>
              <td>{exchange.volume_24h}</td>
              <td>{exchange.markets}</td>
              <td><a href={exchange.url} target="_blank" rel="noopener noreferrer">Visitar</a></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Exchanges;
